class AuthSwitcher extends HTMLElement {
  constructor() {
    super();

    this.loginSwitcher = this.querySelector('.login-switcher');

    this.loginDisclaimer = this.querySelector('.login-disclaimer');

    this.socialLogin = this.querySelector('[name="hiko-container"]');

    this.loginContainer = this.querySelector('.login-standard .standard-login-fields');
    this.loginBackToSign = this.querySelector('.back-to-sign-in');
    this.loginTitle = this.querySelector('#login');


    this.forgotLink = this.querySelector('.recovery-pass-link');
    this.forgotContainer = this.querySelector('.forgot-password');
    this.forgotTitle = this.querySelector('#recover');
    this.forgotBackTo = this.querySelector('.back-to-email-sign');

    this.loginWithEmail = this.querySelector('.login-switcher__email');

    this.loginWithEmail.addEventListener('click', (e) => {
      e.preventDefault();
      this.toStandardLogin();
    });

    this.loginBackToSign.addEventListener('click', (e) => {
      e.preventDefault();
      this.backToSign();
    });

    this.forgotLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.forgotPass();
    });

    this.forgotBackTo.addEventListener('click', (e) => {
      e.preventDefault();
      this.forgotContainer.classList.add('hidden');
      this.toStandardLogin();
    });
  }

  toStandardLogin() {
    this.loginContainer.classList.remove('hidden');
    this.loginSwitcher.classList.add('hidden');
    this.loginTitle.classList.remove('hidden');
    this.forgotTitle.classList.add('hidden');
    this.socialLogin.classList.add('hidden');
    this.loginDisclaimer.classList.remove('hidden');
  }

  backToSign() {
    this.loginContainer.classList.add('hidden');
    this.loginSwitcher.classList.remove('hidden');
    this.loginTitle.classList.remove('hidden');
    this.forgotTitle.classList.add('hidden');
    this.socialLogin.classList.remove('hidden');
    this.loginDisclaimer.classList.remove('hidden');
  }

  forgotPass() {
    this.loginContainer.classList.add('hidden');
    this.forgotContainer.classList.remove('hidden');
    this.loginTitle.classList.add('hidden');
    this.forgotTitle.classList.remove('hidden');
    this.socialLogin.classList.add('hidden');
    this.loginDisclaimer.classList.add('hidden');
  }
}

customElements.define('auth-switcher', AuthSwitcher);

class PrivacyNotice extends HTMLElement {
  constructor() {
    super();

    this.termsCheckbox = this.querySelector('#terms-action-checkbox');
    this.newsletterCheckbox = this.querySelector('#newsletter-subscribe-checkbox');

    this.registerBtn = document.querySelector('.customer-register-btn');
    this.newsletterInput = document.querySelector('.customer-subscribe-newsletter');

    this.termsCheckbox.addEventListener('click', () => {
      this.toggeleRegister();
    });

    this.newsletterCheckbox.addEventListener('click', () => {
      this.toggeleSubscription();
    });
  }

  toggeleRegister() {
    this.termsCheckbox.checked ? this.registerBtn.removeAttribute('disabled')
      : this.registerBtn.setAttribute('disabled', true);
  }

  toggeleSubscription() {
    this.newsletterCheckbox.checked ? this.newsletterInput.setAttribute('value', 1)
      : this.newsletterInput.setAttribute('value', 0);
  }
}

customElements.define('privacy-notice', PrivacyNotice);

class RegistrationSwitcher extends HTMLElement {
  constructor() {
    super();

    this.b2bElement = document.querySelector('#b2b-handsfree-wrapper');
    this.standardRegister = document.querySelector('#create_customer');
    this.backToStandardRegister = document.querySelector('section.back-to-register');

    this.pageTitle = document.querySelector('.customer-page-title h1');


    this.toB2bLink = this.querySelector('.register-as-company');

    this.checkActive();

    this.toB2bLink.addEventListener('click', (event) => {
      event.preventDefault();

      this.toB2b();
    });

    this.backToStandardRegister.addEventListener('click', (event) => {
      event.preventDefault();

      this.toStandardRegistration();
    });
  }

  checkActive() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.get('b2b')) {
      this.toB2b();
    } else {
      this.toStandardRegistration();
    }
  }

  toB2b() {
    this.pageTitle.innerHTML = this.pageTitle.getAttribute('data-b2b-title')
    this.standardRegister.classList.remove('active');
    this.b2bElement.classList.add('active');
    this.toB2bLink.classList.add('hidden');
    this.backToStandardRegister.classList.remove('hidden');
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  toStandardRegistration() {
    this.pageTitle.innerHTML = this.pageTitle.getAttribute('data-standard-title')
    this.standardRegister.classList.add('active');
    this.b2bElement.classList.remove('active');
    this.toB2bLink.classList.remove('hidden');
    this.backToStandardRegister.classList.add('hidden');
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}

customElements.define('registration-switcher', RegistrationSwitcher);
